import type { IconDef } from '../types';
import { check } from './check';

/**
 * A check inside an OUTLINED circle — the quieter sibling of
 * `tick-with-container`, whose container is a solid disc with the check knocked
 * out of it. Used where a completion mark should record what happened without
 * the weight of a filled disc.
 *
 * The ring is stroked rather than drawn as a filled annulus so it inherits the
 * icon tone through `currentColor` like every other path, and the check is the
 * shared `check` glyph rather than a second copy — the two icons must stay the
 * same checkmark, and duplicating the path is how that drifts.
 *
 * Figma names this layer "Check circled filled"; the name here describes the
 * shape it actually draws (ADR-020 Rule 4 — the repo is the naming authority).
 * Measured at 20×20 in the design and scaled into the set's 24×24 frame, so the
 * ring is r=11.4 centred and the stroke 1.2 (both 1.2× the design's 9.5 and 1).
 */
export const tickWithOutlinedContainer: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M12 0.6A11.4 11.4 0 1 1 12 23.4A11.4 11.4 0 1 1 12 0.6Z',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: '1.2',
    },
    ...check.paths,
  ],
};
